<style type="text/css" media="screen">
</style>
<template>
  <div>
    <v-row class="mb-5">
      <v-col cols="8" md="6">
        <v-text-field
          v-model="trip_serch_query"
          :placeholder="$lang.TRIP_SEARCH"
          outlined
          rounded
          dense
          append-icon="mdi-magnify"
          @keyup="getDispatchHistory"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="4" md="2" class="pt-3">
        <div @click="openFilterDialog" class="cursor-pointer w-max-content">
          <filter-btn :filter_count="dispatch_filter_data.filter_count" />
        </div>

        <!-- <v-btn  rounded depressed  outlined  class="download-svg-btn" width="85" @click="dialog.flag=true">
					<v-icon>mdi-filter</v-icon>
					{{$lang.FILTER}}
				</v-btn> -->
      </v-col>
    </v-row>

    <div>
      <v-data-table
        :headers="headers"
        :items="trip_list"
        :hide-default-footer="true"
        :disable-sort="true"
        :items-per-page="$keys.PAGE_LENGTH"
        class="elevation-1 custome-header-bg custome-table-body"
        :loading="table_loading"
        @click:row="gotoTripDetails"
      >
        <template v-slot:item.delivery_agent="{ item }">
          <p>{{ item.delivery_agent_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.delivery_agent_number }}</p>
        </template>
        <template v-slot:item.date="{ item }">
          <span>{{ item.created_date }},{{ item.created_time }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn small fab text @click="gotoTripDetails(item)">
            <img src="@/assets/arrow-right.svg" alt="" />
          </v-btn>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.trip_completed" class="trip_completed"
            >Completed</span
          >
          <span v-if="!item.trip_completed" class="trip_ongoing">On going</span>
        </template>
        <!--empty state  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_TRIP" />
        </template>
      </v-data-table>

      <v-pagination
        class="custome-pagination"
        v-model="page_number"
        :total-visible="7"
        :length="total_page_count"
        @input="getDispatchHistory"
      ></v-pagination>

      <!-- <shipment-list/> -->
      <trip-filter
        :dialog="dialog"
        :filter_data="filter_data"
        @filter="getDispatchHistory"
      />
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
export default {
  components: {
    TripFilter: () => import("./child/TripFilter"),
    FilterBtn: () => import("@/components/common-components/FilterBtn.vue"),
  },
  watch: {
    selected: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getShipmentIdList();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      total_page_count: 1,
      page_number: 1,
      table_loading: false,
      trip_list: [],
      trip_serch_query: "",
      headers: [
        { text: "Trip ID", align: "start", value: "trip_id" },
        { text: "Delivery Agent", value: "delivery_agent" },
        { text: "Packages", value: "shipment_count" },
        { text: "Stops #", value: "num_of_stops" },
        { text: "Line name", value: "line_name" },
        { text: "Date, Time", value: "date" },
        { text: "Status", value: "status" },
        { text: "", value: "action" },
      ],
      dialog: {
        flag: false,
      },
      filter_data: {
        agent_id_list: [],
        line_id_list: [],
        status_list: [],
        filter_date_from: "",
        filter_date_to: "",
        filter_count: 0,
      },
    };
  },
  /* computed  property*/
  computed: mapGetters({
    dispatch_filter_data: "dispatch_history/getDispatchShipmentFilter",
  }),
  created() {
    this.$store.dispatch("drawer/setActiveTab", -1);
    this.getDispatchHistory();
  },
  methods: {
	/* Open filter dialog */   
	openFilterDialog(){
		this.filter_data.agent_id_list=this.dispatch_filter_data.agent_id_list
		this.filter_data.line_id_list=this.dispatch_filter_data.line_id_list
		this.filter_data.status_list=this.dispatch_filter_data.status_list
		this.filter_data.filter_date_from=this.dispatch_filter_data.filter_date_from
		this.filter_data.filter_date_to=this.dispatch_filter_data.filter_date_to
		this.filter_data.filter_count=this.dispatch_filter_data.filter_count
		this.dialog.flag=true
	},
    /* fetching shipment list */
    getDispatchHistory() {
      const self = this;
      this.$store.dispatch("setPageLoader", true);
      let is_completed=""
      if(this.dispatch_filter_data.status_list.length>1)
        is_completed=''
      else if(this.dispatch_filter_data.status_list[0]== "On going")
        is_completed='No'
      else if(this.dispatch_filter_data.status_list[0]== "Completed")
        is_completed='Yes'


      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.trip_serch_query,
        agent_id_list: JSON.stringify(this.dispatch_filter_data.agent_id_list),
        line_id_list: JSON.stringify(this.dispatch_filter_data.line_id_list),
        filter_date_from: this.dispatch_filter_data.filter_date_from,
        filter_date_to: this.dispatch_filter_data.filter_date_to,
        'is_completed': is_completed,
        is_list: true,
      };
      self.table_loading = true;

      const successHandler = (response) => {
        console.log(response);
        if (response.data.success) {
          this.trip_list = response.data.trip_list;
          this.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
        self,
        self.$urls.GET_TRIP_HISTORY,
        params,
        successHandler,
        null,
        null,
        finallyHandler
      );
    },
    gotoTripDetails(item) {
      this.$router.push({
        name: "dispatch-details",
        params: { trip_id: this.encript(item.trip_id) },
      });
    },
  },
};
</script>